import React from 'react';
import { Section } from './ui/Section';
import { Card } from './ui/Card';
import { Eye, Target, Heart } from 'lucide-react';
export function Values() {
  return <Section bg="offwhite" data-id="element-489">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-490">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy mb-4" data-id="element-491">
          Our Core Philosophy
        </h2>
        <p className="text-gray-600" data-id="element-492">Driven by purpose, guided by values.</p>
      </div>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-493">
        <Card delay={0.1} className="border-t-4 border-t-gold" data-id="element-494">
          <div className="w-12 h-12 bg-navy/5 rounded-full flex items-center justify-center mb-6" data-id="element-495">
            <Eye className="h-6 w-6 text-navy" data-id="element-496" />
          </div>
          <h3 className="text-xl font-bold text-navy mb-3" data-id="element-497">Our Vision</h3>
          <p className="text-gray-600 leading-relaxed" data-id="element-498">
            To be the preferred financial solutions provider for individuals and
            Small to Medium Enterprises (SMEs) in Botswana.
          </p>
        </Card>

        <Card delay={0.2} className="border-t-4 border-t-navy" data-id="element-499">
          <div className="w-12 h-12 bg-gold/10 rounded-full flex items-center justify-center mb-6" data-id="element-500">
            <Target className="h-6 w-6 text-gold-dark" data-id="element-501" />
          </div>
          <h3 className="text-xl font-bold text-navy mb-3" data-id="element-502">Our Mission</h3>
          <p className="text-gray-600 leading-relaxed" data-id="element-503">
            To embolden and capacitate the communities we serve to achieve
            financial stability and success, while exceeding the expectations of
            our customers, shareholders, and associates.
          </p>
        </Card>

        <Card delay={0.3} className="border-t-4 border-t-gold" data-id="element-504">
          <div className="w-12 h-12 bg-navy/5 rounded-full flex items-center justify-center mb-6" data-id="element-505">
            <Heart className="h-6 w-6 text-navy" data-id="element-506" />
          </div>
          <h3 className="text-xl font-bold text-navy mb-3" data-id="element-507">Our Values</h3>
          <ul className="space-y-3 text-gray-600" data-id="element-508">
            <li data-id="element-509">
              <strong className="text-navy" data-id="element-510">Trustworthy:</strong> Integrity,
              honesty, reliability.
            </li>
            <li data-id="element-511">
              <strong className="text-navy" data-id="element-512">Innovation:</strong> New ideas to
              improve service.
            </li>
            <li data-id="element-513">
              <strong className="text-navy" data-id="element-514">Excellence:</strong> Distinction in
              all we do.
            </li>
            <li data-id="element-515">
              <strong className="text-navy" data-id="element-516">Customer-Centric:</strong> Exceeding
              expectations.
            </li>
          </ul>
        </Card>
      </div>
    </Section>;
}